import { PiggyBank } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgPiggyBank = mkIcon(PiggyBank);